//  icons
import {
  FiGithub, FiInstagram, FiLayout, FiLinkedin, FiMail,
  FiMapPin, FiPenTool, FiSettings, FiTag, FiYoutube
} from 'react-icons/fi';

// companies icons
import BehanceBrandIcon from './assets/img/brands/behance.png';
import DribbbleBrandIcon from './assets/img/brands/dribbble.png';
import FiverBrandIcon from './assets/img/brands/fiverr.png';
import FreelancerBrandIcon from './assets/img/brands/freelancer.png';
import UpworkBrandIcon from './assets/img/brands/upwork.png';

// projects images
import Project1 from './assets/img/projects/p1.png';
import Project2 from './assets/img/projects/p2.png';
import Project3 from './assets/img/projects/p3.png';
import Project4 from './assets/img/projects/p4.png';
import Project5 from './assets/img/projects/p5.png';
import Project6 from './assets/img/projects/p6.png';

// skills images
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg8 from './assets/img/skills/figma.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg5 from './assets/img/skills/nextjs.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg4 from './assets/img/skills/reactjs.png';

// testimonial images
import TestiImage1 from './assets/img/testimonials/testimonial-1.webp';
import TestiImage2 from './assets/img/testimonials/testimonial-2.webp';
import TestiImage3 from './assets/img/testimonials/testimonial-3.webp';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'portfolio',
    href: 'portfolio',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'testimonials',
    href: 'testimonials',
  },
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  {
    icon: <FiYoutube />,
    href: 'https://www.youtube.com/channel/UClFMaWxT-X3p1Op0VH0yY-A',
  },
  {
    icon: <FiInstagram />,
    href: 'https://www.instagram.com/shakil_prodev/',
  },
  {
    icon: <FiGithub />,
    href: 'https://github.com/webshakil',
  },
  {
    icon: <FiLinkedin />,
    href: 'https://www.linkedin.com/in/shakilkamrandev/',
  },
];

// companies
export const brands = [
  {
    img: FreelancerBrandIcon,
    href: 'https://www.freelancer.com/u/ShakilDigitaLife',
  },
  {
    img: UpworkBrandIcon,
    href: 'https://www.upwork.com/freelancers/~0120025f824d5325b4',
  },
  {
    img: FiverBrandIcon,
    href: 'https://www.fiverr.com/shakilcodingmon',
  },
  {
    img: BehanceBrandIcon,
    href: '',
  },
  {
    img: DribbbleBrandIcon,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    name: 'Frontend Tailwind CSS',
    category: 'UI/UX design',
  },
  {
    id: '2',
    image: Project2,
    name: 'Ecommerce By Node And Rect',
    category: 'web development',
  },
  {
    id: '3',
    image: Project3,
    name: 'Learning Management System Next & Node',
    category: 'UI/UX design',
  },
  {
    id: '4',
    image: Project4,
    name: 'Dashboard By React Styled Component',
    category: 'branding',
  },
  {
    id: '5',
    image: Project5,
    name: 'Ecommerce Solution By MERN STACK and RTK Query',
    category: 'web development',
  },
  {
    id: '6',
    image: Project6,
    name: 'Shopping Cart By Typescript,React & ReduxToolkit',
    category: 'web development',
  },
];

// projects
export const projectsNav = [
  {
    name: 'all',
  },
  {
    name: 'UI/UX Design',
  },
  {
    name: 'web development',
  },
  {
    name: 'branding',
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Web Design',
    description:
      'Responsive UI/UX pixel perfect solutions by Tailwindcss, custom css and React styled componet. Most importantly, a proper understanding of the users makes it simple to convert them into loyal customers. As a result, your actual sales will increase.',
  },
  {
    icon: <FiSettings />,
    name: 'Web Development',
    description:
      'Critical solutions of web like Rect/Vue/node/ and associated libaray or frameworks along with mobile applications by React native. Our modern solutions and design will definetely help to promote a companys brand name.',
  },
  {
    icon: <FiPenTool />,
    name: 'Branding',
    description:
      'Choose from multiple ad formats and advertise on the world largest professional network. Explore social media ad formats & specifications designed to help you achieve different goals.',
  },
  {
    icon: <FiTag />,
    name: 'SEO',
    description:
      'SEO related solutions are provided because it makes your website more visible, and that means more traffic and more opportunities to convert prospects into customers..',
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Thanks so much for your business throughout the past few years. We want you to know that we are truly grateful to our customers.',
    authorName: 'Lyndel Hurley',
    authorPosition: 'Head of Marketing, apTask',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'Since having our new website built by Thrive, we have seen a 200% increase in the number of online contact forms being filled out and returned to us. Matt and his team worked closely with us to provide a site that met all of the criteria that we were looking for. The end result was a website that is attractive, organized and effective. Thanks to Thrive for all of your hard work and support!',
    authorName: 'Megan Seaford',
    authorPosition: 'Head of Design, RWDC',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'With Thrive’s help, we were able to increase the functionality of our website dramatically while cutting our costs. Our website is much more easy to use, has tons of more features than before and is incredibly easy to maintain. We could not be more happy with our new website! Thanks Thrive!',
    authorName: 'Diana Rodrigues',
    authorPosition: 'Head of Design, coNexus',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at chumkysk@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Dhaka, Bangladesh',
    description: 'Serving clients worldwide',
  },
];
